import type { CSSProperties } from 'react';
import type { pricingHonestySection } from '../../../../app/_shared/marketing/landingContent';
import { withEmphasis } from './emphasisText';
import './problemAndWhy.css';

type Item = (typeof pricingHonestySection.items)[number];

type Props = {
  eyebrow: string;
  h2: string;
  lead: string;
  items: readonly Item[];
  closer: string;
};

/**
 * Monetization honesty. Rendered as plain bordered statements rather than cards — this section
 * earns its credibility by looking like a disclosure, not like another feature pitch. Read the
 * claims block on `pricingHonestySection` before touching the copy.
 */
export function PricingHonestySection({ eyebrow, h2, lead, items, closer }: Props) {
  return (
    <section className="stmt-section" aria-labelledby="pricing-heading">
      <header className="stmt-section__head">
        <p className="stmt-section__eyebrow">{eyebrow}</p>
        <h2 id="pricing-heading" className="ml-heading-serif ml-text-heading stmt-section__title">
          {h2}
        </h2>
        <p className="stmt-section__lead">{lead}</p>
      </header>

      <div className="stmt-grid">
        {items.map((item, index) => (
          <article
            key={item.id}
            className="stmt-item ml-revealStaggerItem"
            style={{ '--reveal-i': index } as CSSProperties}>
            <h3 className="ml-heading-sans stmt-item__title">{item.title}</h3>
            <p className="stmt-item__body">{withEmphasis(item.body)}</p>
          </article>
        ))}
      </div>

      <p className="stmt-section__closer">{withEmphasis(closer)}</p>
    </section>
  );
}
